import React from "react";


export function ContactPage(){

    return(
        <div className="ContactPage">
            <h2>Contact Page</h2>
        </div>
    )
}